import { render, staticRenderFns } from "./index.vue?vue&type=template&id=495fb2c8&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "495fb2c8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qingchi/workspace/mimi/mer_mer_admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('495fb2c8')) {
      api.createRecord('495fb2c8', component.options)
    } else {
      api.reload('495fb2c8', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=495fb2c8&scoped=true", function () {
      api.rerender('495fb2c8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/allCouponList/index.vue"
export default component.exports